interface CustomPathHolderObject {
  as: string;
  data: {
    showSubNav: boolean;
    subNavItems: [];
  };
  path: string;
  type: string;
}
export class CustomPathHolder {
  public mPathObject: CustomPathHolderObject;
  public mPathParent: CustomPathHolderObject;

  constructor() {}
  public initialize(aConstructorParams: any) {
    this.mPathObject = aConstructorParams.pathObject;
    this.mPathParent = aConstructorParams.pathParent;

    //propagate subnav
    if (this.mPathParent && this.mPathParent.data && this.mPathParent.data.showSubNav == true) {
      // Adding check to verify that this.mPathObject.data is not null
      if (this.mPathObject.data != null) {
        if (this.mPathObject.data.showSubNav != false) {
          this.mPathObject.data.showSubNav = this.mPathParent.data.showSubNav;
          this.mPathObject.data.subNavItems = this.mPathParent.data.subNavItems;
        }
      } else {
        // Cannot continue, value is null
        return;
      }
    }

    if (this.mPathObject.type == 'internal') {
      return;
    }
    if (this.mPathObject.type == 'external') {
      return;
    }

    App.INSTANCE.appRouter?.addRouterEvent(this.mPathObject.path, {
      as: this.mPathObject.as,
      uses: (params, query) => {
        App.INSTANCE.routeBasedOnType(this.mPathObject, params, query, this.mPathParent);
      },
    });
  }
}
